import { EIcon } from 'common/enum/misc.enum';

type TCompetenceOptions = Partial<Record<ECompetenceGroup, EIcon[]>>;

/**
 * enum values correspond to a translation key
 */
export enum ECompetenceGroup {
  PEOPLE_AND_BODIES = 'peopleAndBodies',
  CREATIVITY_AND_COMMUNICATION = 'creativityAndCommunication',
  ACTIVITIES_AND_NATURE = 'activitiesAndNature',
  PRODUCTIVITY_AND_LEARNING = 'productivityAndLearning',
  GEOMETRY_AND_NUMBERS = 'geometryAndNumbers',
  MEDIA = 'media',
  SYMBOLS = 'symbols',
}

export const COMPETENCE_DOMAIN_ICON_OPTIONS: TCompetenceOptions = {
  [ECompetenceGroup.PEOPLE_AND_BODIES]: [
    EIcon.USER,
    EIcon.GIRL,
    EIcon.GROUP,
    EIcon.OWNER,
    EIcon.USER_NEW,
    EIcon.ADMIN,
    EIcon.COMPETENCE3,
    EIcon.COMPETENCE2,
    EIcon.SMILE,
    EIcon.SMILE2,
    EIcon.THUMBS_UP,
    EIcon.POINT_UP,
    EIcon.POINT_RIGHT,
    EIcon.HAND,
    EIcon.SEE,
    EIcon.EAR,
    EIcon.RATE,
    EIcon.CLASS,
  ],
  [ECompetenceGroup.CREATIVITY_AND_COMMUNICATION]: [
    EIcon.COMPETENCE5,
    EIcon.COMPETENCE,
    EIcon.SUN,
    EIcon.BRUSH,
    EIcon.LOADER,
    EIcon.EDIT,
    EIcon.GLASSES,
    EIcon.STAR,
    EIcon.SPEAK,
    EIcon.AI,
    EIcon.SCRIBBLE,
    EIcon.LIGHTNING,
    EIcon.HIGHLIGHT,
    EIcon.SCISSORS,
    EIcon.MUSIC,
    EIcon.MOON,
    EIcon.BUBBLE,
    EIcon.BUBBLE_CHECK,
    EIcon.BUBBLE_HELP,
    EIcon.BUBBLE_PROBLEM,
    EIcon.BUBBLE_QUOTE,
  ],
  [ECompetenceGroup.ACTIVITIES_AND_NATURE]: [
    EIcon.HANDS_UP,
    EIcon.RUN,
    EIcon.FOOTBALL,
    EIcon.STAND,
    EIcon.MOVE,
    EIcon.BICYCLE,
    EIcon.COMPETENCE4,
    EIcon.LEAF,
    EIcon.SNOWFLAKE,
    EIcon.BANDAGE,
    EIcon.TEMPERATURE,
    EIcon.HEART,
  ],
  [ECompetenceGroup.PRODUCTIVITY_AND_LEARNING]: [
    EIcon.FOLDER,
    EIcon.NEW_FOLDER,
    EIcon.DOCUMENT_PEN,
    EIcon.DOCUMENT,
    EIcon.DOCUMENT_LINES,
    EIcon.DOCUMENT_CHECK,
    EIcon.COPY,
    EIcon.EMAIL,
    EIcon.INVITE,
    EIcon.LINK,
    EIcon.NOTIFICATION,
    EIcon.PRINT,
    EIcon.CALENDAR,
    EIcon.ARCHIVE,
    EIcon.CHART,
    EIcon.SEARCH,
    EIcon.BOOK,
    EIcon.GRADUATION,
    EIcon.MAP,
    EIcon.WEB,
    EIcon.LOCATION,
  ],
  [ECompetenceGroup.GEOMETRY_AND_NUMBERS]: [
    EIcon.AREA,
    EIcon.SIZE,
    EIcon.LENGTH,
    EIcon.THREE_D,
    EIcon.ROOM,
    EIcon.LAYERS,
    EIcon.SUM,
    EIcon.ANGLE,
    EIcon.TEN,
    EIcon.HUNDRED,
    EIcon.THOUSAND,
    EIcon.PERCENTAGE,
    EIcon.DIVIDE,
  ],
  [ECompetenceGroup.MEDIA]: [
    EIcon.DOWNLOAD,
    EIcon.BOOK_OPEN,
    EIcon.VIDEO,
    EIcon.PLAY,
    EIcon.PHONE,
    EIcon.GAMING,
    EIcon.PRESENTATION,
  ],
  [ECompetenceGroup.SYMBOLS]: [
    EIcon.PLUS_CIRCLE,
    EIcon.MINUS_CIRCLE,
    EIcon.CHECK_CIRCLE,
    EIcon.INFO,
    EIcon.HELP,
    EIcon.REMOVE,
    EIcon.TIME,
    EIcon.DELETE,
    EIcon.HOME,
    EIcon.HOME_ADD,
    EIcon.INSTITUTION,
    EIcon.INSTITUTION2,
    EIcon.INSTITUTION3,
    EIcon.WARNING,
    EIcon.CHECK,
    EIcon.PLUS,
    EIcon.CLOSE,
    EIcon.SETTINGS,
    EIcon.APPROVE,
    EIcon.KEY,
    EIcon.CREDIT_CARD,
    EIcon.ARROW_LEFT,
    EIcon.ARROW_RIGHT,
    EIcon.ARROW_UP,
    EIcon.ARROW_DOWN,
    EIcon.GROW,
    EIcon.SYNC,
    EIcon.LOCK,
    EIcon.SHIELD,
    EIcon.HAMMER,
    EIcon.CROSS,
    EIcon.DAVID_STAR,
  ],
};
